import { BrandsEnum } from '@models/enums/brands.enum';

/**
 * Used for *.robyn.io / *.robyn.com subdomains.
 * The subdomain itself is a brand alias (e.g. "kearnsbrothers.robyn.io").
 */
const ROBYN_SUBDOMAIN_MAP = new Map<string, BrandsEnum>([
  [BrandsEnum.KEARNS_BROTHERS, BrandsEnum.KEARNS_BROTHERS],
  [BrandsEnum.KEARNS, BrandsEnum.KEARNS_BROTHERS],
  [BrandsEnum.SHANCO, BrandsEnum.SHANCO],
  [BrandsEnum.MUSIC_CITY_ROOFERS, BrandsEnum.MUSIC_CITY_ROOFERS],
]);

/**
 * Used for direct brand domains (e.g. "feazelinc.com", "goshanco.com").
 * The .com suffix is stripped before matching.
 */
const DOMAIN_BRAND_MAP = new Map<string, BrandsEnum>([
  ['kearnsbrothers', BrandsEnum.KEARNS_BROTHERS],
  ['feazelinc', BrandsEnum.FEAZEL],
  ['musiccityroofers', BrandsEnum.MUSIC_CITY_ROOFERS],
  ['goshanco', BrandsEnum.SHANCO],
]);

function normalizeHostname(host?: string): string {
  if (!host) {
    return '';
  }

  const hostWithoutPort = host.split(':')[0].trim().toLowerCase();
  return hostWithoutPort.startsWith('www.')
    ? hostWithoutPort.slice(4)
    : hostWithoutPort;
}

export function getBrandFromHostname(host?: string): BrandsEnum {
  const hostname = normalizeHostname(host);

  if (!hostname) {
    return BrandsEnum.FEAZEL;
  }

  if (hostname.includes('.robyn')) {
    const subdomain = hostname.split('.')[0];
    for (const [keyword, brand] of ROBYN_SUBDOMAIN_MAP) {
      if (subdomain.includes(keyword)) {
        return brand;
      }
    }
    return BrandsEnum.FEAZEL;
  }

  const domainWithoutTld = hostname.split('.com')[0];
  for (const [keyword, brand] of DOMAIN_BRAND_MAP) {
    if (domainWithoutTld.includes(keyword)) {
      return brand;
    }
  }

  return BrandsEnum.FEAZEL;
}
